export default "__VITE_ASSET__BZR53GqL__"